import * as types from './actionTypes';
import * as formActionTypes from '../../../form/actionTypes';
import * as formActions from '../../../form/actions';
import * as api from '../../../../common/api';
import * as selectors from './selectors';
import { push, CALL_HISTORY_METHOD } from 'connected-react-router';
import _ from 'lodash';
import * as customer from '../../profile/selectors';

export const fetchHardwareProductsList = id => ({
    types: [types.FETCH_HARDWARE_PRODUCTS_REQUEST, types.FETCH_HARDWARE_PRODUCTS_SUCCESS, types.FETCH_HARDWARE_PRODUCTS_FAILURE],
    apiCall: () => api.getHardwareProducts(id)
});

export const setHardwareSerialNumber = (serialNumber, isValid) => ({
    type: types.SET_HARDWARE_SERIAL_NUMBER,
    serialNumber,
    isValid
});

export const setCardSerialNumber = (serialNumber, isValid) => ({
    type: types.SET_CARD_SERIAL_NUMBER,
    serialNumber,
    isValid
});

export const addHardwareChangeStep = stepNumber => ({
    type: types.ADD_HARDWARE_CHANGE_STEP,
    stepNumber
});

export const getHardwareBySerial = (serialNumber) => ({
    types: [types.FETCH_HARDWARE_DEVICE_BY_SERIAL_REQUEST, types.FETCH_HARDWARE_DEVICE_BY_SERIAL_SUCCESS, types.FETCH_HARDWARE_DEVICE_BY_SERIAL_FAILURE],
    apiCall: () => api.getDevices(serialNumber),
});

export const getCardBySerial = (serialNumber) => ({
    types: [types.FETCH_CARD_DEVICE_BY_SERIAL_REQUEST, types.FETCH_CARD_DEVICE_BY_SERIAL_SUCCESS, types.FETCH_CARD_DEVICE_BY_SERIAL_FAILURE],
    apiCall: () => api.getDevices(serialNumber),
});

export const searchSerial = (serialNumber) => ({
    types: [types.SEARCH_SERIAL_REQUEST, types.SEARCH_SERIAL_SUCCESS, types.SEARCH_SERIAL_FAILURE],
    apiCall: () => api.getDevices(serialNumber),
    data: { serialNumber }
});

export const resetSearch = () => ({
    type: types.RESET_SEARCH
});

export const getHardwareProductDetails = (productId, serialNumber) => ({
    types: [types.FETCH_HARDWARE_DEVICE_DETAILS_BY_SERIAL_REQUEST, types.FETCH_HARDWARE_DEVICE_DETAILS_BY_SERIAL_SUCCESS, types.FETCH_HARDWARE_DEVICE_DETAILS_BY_SERIAL_FAILURE],
    apiCall: () => api.getHardwareProductDetails(productId, serialNumber),
});

export const getHardwareProductSmb2FirmwareVersion = (serialNumber) => ({
    types: [types.FETCH_SMB2_FIRMWARE_VERSION_BY_SERIAL_REQUEST, types.FETCH_SMB2_FIRMWARE_VERSION_BY_SERIAL_SUCCESS, types.FETCH_SMB2_FIRMWARE_VERSION_BY_SERIAL_FAILURE],
    apiCall: () => api.getSmb2FirmwareVersion(serialNumber),
});

export const toggleProductToCancelFlag = key => ({
    type: types.TOGGLE_PRODUCT_TO_CANCEL_FLAG,
    agreementDetailId: key
});


export const cancelHardwareProducts = (formName) => (dispatch, getState) => {
    const actualState = getState();
    const hardwareList = selectors.getHardwareProducts(actualState).productsList;
    _(hardwareList)
        .filter(x => x.isToCancel === true)
        .map(x => x.commercialProductAgreementDetailId)
        .uniq()
        .value()
        .forEach(agreementDetailId => {
            const action = {
                types: [types.CANCEL_HARDWARE_PRODUCT_TO_REQUEST, types.CANCEL_HARDWARE_PRODUCT_TO_SUCCESS, types.CANCEL_HARDWARE_PRODUCT_TO_FAILURE],
                apiCall: () => api.cancelHardwareProduct(agreementDetailId)
            };
            dispatch(action);
        });

    // const customerId = customer.getCustomerID(actualState);
     return dispatch(formActions.resetForm(formName));
};

export const clearHardwareFormData = () => ({
    type: types.ADD_HARDWARE_PRODUCT_CLEAR,
});

export const backToProfileView = () => (dispatch, getState) => {
     const customerId = customer.getCustomerID(getState());
     return dispatch(() => dispatch(push(`/customer/${customerId}`)));
};


export const clearCancelHardwareFormData = () => ({
    type: types.CANCEL_HARDWARE_PRODUCT_CLEAR,
});

export const addHardwareProducts = () => (dispatch, getState) => {    
    const state = getState();
    const formData = selectors.addHardwareFormData(state);
    const customerId = customer.getCustomerID(state);
    const addHardwareAction = {
        types: [types.ADD_HARDWARE_PRODUCT_REQUEST, types.ADD_HARDWARE_PRODUCT_SUCCESS, types.ADD_HARDWARE_PRODUCT_FAILURE],
        apiCall: () => api.addHardwareProduct(customerId, formData.box.serialNumber, formData.card.serialNumber, formData.isBundledHardware)
    }
    dispatch(addHardwareAction).then(() => dispatch(clearHardwareFormData));
};

export const saveSerial = (customerId, agreementDetailsId, hardwareDetails) => ({
    types: [types.SAVE_SERIAL_REQUEST, types.SAVE_SERIAL_SUCCESS, types.SAVE_SERIAL_FAILURE],
    apiCall: () => api.saveSerial(customerId, agreementDetailsId, hardwareDetails)
});

export const updateSerial = (agreementDetailsId, key, serialNumber) => ({
    type: types.UPDATE_SERIAL,
    agreementDetailsId, 
    key, 
    serialNumber
});

export const saveStart = () => ({
    type: types.SAVE_START
});

export const saveStop = () => ({
    type: types.SAVE_STOP
});